<template>
  <form class="main-modal main-modal_w700 offices-modal">
    <div class="main-modal__title">
      <p>Niederlassung</p>
    </div>

    <div class="main-form__box">
      <label class="main-form__label">Büroname</label>
      <input
        type="text"
        class="main-form__input"
        v-model="office.address"
        placeholder="Büro Wien"
        :disabled="!$guard('write', 'Offices')"
      />
    </div>

    <div class="main-form__box">
      <label class="main-form__label">Radius (m)</label>
      <input
        type="text"
        class="main-form__input"
        v-model="office.radius"
        @change="onChangeRadius"
        placeholder="1000m"
        :disabled="!$guard('write', 'Offices')"
      />
    </div>

    <div class="main-form__box">
      <div id="map"></div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span
        @click="cancel"
        class="main-button main-button_cancel"
        v-text="$t('global.cancel')"
      ></span>
      <button
        class="main-button main-button_success"
        :class="{
          disabled: !isValid,
        }"
        :disabled="!isValid || !$guard('write', 'Offices')"
        @click.prevent="onSave"
      >
        {{ $t("global.save") }}
      </button>
    </div>

    <modal
      :show="showAutocomplete"
      :showBtn="false"
      :dark="true"
      @close="toggleAutocomplete"
    >
      <autocomplete
        :autocompleteValue="autocompleteValue"
        @done="fillAddress"
        @close="toggleAutocomplete"
      />
    </modal>
  </form>
</template>

<script>
import autocomplete from '@/components/controls/autocomplete'
import { mapGetters, mapMutations } from 'vuex'

function generateGeoJSONCircle(center, radius, numSides = 360) {
    const points = []
    const degreeStep = 360 / numSides

    for (let i = 0; i < numSides; i++) {
        // eslint-disable-next-line no-undef
        const gpos = google.maps.geometry.spherical.computeOffset(
            center,
            radius,
            degreeStep * i,
        )
        points.push({
            lat: gpos.lat(),
            lng: gpos.lng(),
        })
    }

    return {
        type: 'Polygon',
        coordinates: points,
    }
}

export default {
    name: 'officesModal',
    components: {
        autocomplete,
    },
    data() {
        return {
            showAutocomplete: false,
            autocompleteValue: '',
            map: null,
            markers: [],
            circles: [],
            point: {
                lat: this.$config.behavior === 'hilfy' ? 48.219308 : 51.234072,
                lng: this.$config.behavior === 'hilfy' ? 16.393125 : 6.80885,
            },
            radius: 10,
            polygon: null,
        }
    },
    computed: {
        ...mapGetters({
            office: 'offices/office',
        }),
        isValid() {
            if (this.office.address === '' || this.office.address === null) return false

            if (this.office.address.length < 3) return false

            if (!Number.isInteger(+this.office.radius)) return false

            return +this.office.radius >= 1
        },
    },
    methods: {
        ...mapMutations({
            setOfficeRadius: 'offices/setRadius',
            setOfficePolygon: 'offices/setPolygon',
        }),
        cancel() {},
        toggleAutocomplete() {
            this.showAutocomplete = !this.showAutocomplete
        },
        fillAddress(e) {
            console.log(e)
        },
        onChangeRadius() {
            if (!Number.isInteger(+this.office.radius)) return

            this.setRadius(+this.office.radius)
            this.printPoint()
            this.printCircle()

            // eslint-disable-next-line no-undef
            const center = new google.maps.LatLng(this.point)
            this.setPolygon(center, this.office.radius)
        },
        setPolygon(center, radius) {
            this.setOfficePolygon(generateGeoJSONCircle(center, radius))
            console.log()
        },
        setRadius(radius) {
            this.setOfficeRadius(radius)
        },
        setPoint({ lat, lng }) {
            this.point.lat = lat
            this.point.lng = lng
        },
        getPoint() {
            return this.point
        },
        printPoint() {
            this.markers.forEach((marker) => {
                marker.setMap(null)
            })

            // eslint-disable-next-line no-undef
            const marker = new google.maps.Marker({
                position: this.getPoint(),
                title: 'Click to zoom',
            })
            this.markers.push(marker)
            marker.setMap(this.map)
        },
        printCircle() {
            const vm = this

            this.circles.forEach((circle) => {
                circle.setMap(null)
            })

            // eslint-disable-next-line no-undef
            const circle = new google.maps.Circle({
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                map: this.map,
                center: this.getPoint(),
                radius: this.office.radius,
            })

            circle.setEditable(this.$guard('write', 'Offices'))
            circle.addListener('radius_changed', function fn() {
                vm.setPoint({
                    lat: this.center.lat(),
                    lng: this.center.lng(),
                })
                vm.printPoint()
                vm.setRadius(Math.round(this.radius))

                vm.setPolygon(this.center, vm.office.radius)
            })
            circle.addListener('center_changed', function fn() {
                vm.setPoint({
                    lat: this.center.lat(),
                    lng: this.center.lng(),
                })
                vm.printPoint()
            })

            // eslint-disable-next-line no-undef
            const center = new google.maps.LatLng(this.point)
            this.setPolygon(center, this.office.radius)
            this.circles.push(circle)
        },
        prepareForm() {
            const point = this.getPoint()

            return {
                id: this.office.id,
                address: this.office.address,
                radius: this.office.radius,
                latitude: point.lat,
                longitude: point.lng,
                polygon: this.office.polygon.coordinates,
            }
        },
        onSave() {
            this.$emit('done', this.prepareForm())
        },
    },
    mounted() {
        if (this.office.id) {
            this.setPoint({
                lng: +this.office.longitude,
                lat: +this.office.latitude,
            })
        }

        this.map = new window.google.maps.Map(document.getElementById('map'), {
            center: this.getPoint(),
            zoom: 11,
            disableDefaultUI: true,
            clickableIcons: false,
            maxZoom: 18,
        })

        this.printPoint()
        this.printCircle()
    },
}
</script>

<style lang="scss" scoped>
.offices-modal {
  #map {
    width: 100%;
    height: 500px;
  }
}
</style>
